import { faCheckCircle, faStar, faTimesCircle } from '@fortawesome/pro-solid-svg-icons'

import {
  Box, Checkbox, ListItem, Text,
} from '@domain-group/suit-theme'

import useStatus from '@hooks/useStatus'
import { generateUrls } from '@hooks/useOrder'

import type { ArtworkReviewPendingOrderModel } from '@models/types'
import useCurrentUser from '@hooks/useCurrentUser'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface ReviewedArtworkListItemProps {
  artworkReview: ArtworkReviewPendingOrderModel,
  filteringPriorityOnly?: boolean,
}

const ReviewedArtworkListItem = (props: ReviewedArtworkListItemProps) => {
  const { artworkReview, filteringPriorityOnly } = props
  const {
    campaign: { address, id: campaignId, priority_campaign_user_ids: priorityUserIds },
    id,
    order_item: { title: orderItemTitle },
    status: { id: statusId },
  } = artworkReview

  const { status } = useStatus({ id: statusId })
  // @ts-expect-error TS2339
  const declined = status?.key === 'declined'

  const { pendingCampaignOrdersUrl } = generateUrls({}, { campaignId })

  const { currentUser } = useCurrentUser()

  // @ts-expect-error TS2345
  const isPriorityCampaignForCurrentUser = priorityUserIds?.includes(currentUser.id)

  if (filteringPriorityOnly && !isPriorityCampaignForCurrentUser) return null

  return (
    // @ts-expect-error TS2339
    <ListItem.WithCheckbox
      boxProps={{
        as: 'a',
        paddingX: 'large',
        paddingTop: 'medium',
        paddingBottom: 'medium',
      }}
      checkbox={(
        <Checkbox
          checked
          color={declined ? 'red' : 'green'}
          fontSize="medium"
          iconChecked={declined ? faTimesCircle : faCheckCircle}
        />
      )}
      key={id}
      href={pendingCampaignOrdersUrl}
      showAngleIcon
    >
      <Box flexDirection="column" marginRight="auto" width={['150px', 'auto']}>
        <Text fontSize="small" marginRight="large" variant="ellipsis">
          {address}
        </Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small" variant="ellipsis">
          {orderItemTitle}
        </Text>
      </Box>

      {isPriorityCampaignForCurrentUser && (
        <Text
          color="blue"
          fontSize="small"
          marginRight="small"
        >
          <FontAwesomeIcon icon={faStar} />
        </Text>
      )}
      {/*
     // @ts-expect-error TS2339 */}
    </ListItem.WithCheckbox>
  )
}

export default ReviewedArtworkListItem
